import { AppShell, EmptyState } from "@wayflyer/flyui";
import { styled } from "styled-components";
import { useIntl } from "react-intl";

const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: var(--sizes-spacing-2);
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 120px);
`;

const Placeholder = () => {
  const intl = useIntl();

  return (
    <AppShell>
      <PlaceholderContainer>
        <EmptyState
          title={intl.formatMessage({
            id: "performance - were processing your data",
            defaultMessage: "We are processing your data",
          })}
          text={intl.formatMessage({
            id: "performance - well email you when your dashboard is ready",
            defaultMessage: "We will email you when your dashboard is ready.",
          })}
        />
      </PlaceholderContainer>
    </AppShell>
  );
};

export default Placeholder;
